
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectLoginError,
  selectIsLoading,
  loginUser,
  LoginAppDispatch,
} from '../../modules/login';

import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import LoginSingupLayout from '../../components/loginSingupLayout';

import {
  Button,
  CheckboxGroup, 
  CheckboxLabel,
  IconPlaceholder,
  Input,
  InputGroup,
  LinkText,
  PasswordInput,
  ErrorText,
  Label,
  Subtext,
  Title
} from './styles';

import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';


const LoginPage: React.FC = () => {
  const dispatch = useDispatch<LoginAppDispatch>();
  const error = useSelector(selectLoginError);
  const isLoading = useSelector(selectIsLoading);

  const [inputEmail, setInputEmail] = useState<string>('');
  const [inputPassword, setInputPassword] = useState<string>('');
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [rememberMe, setRememberMe] = useState<boolean>(false);

  React.useEffect(() => {
    const savedEmail = localStorage.getItem('rememberedEmail');
    if (savedEmail) {
      setInputEmail(savedEmail);
      setRememberMe(true);
    }
  }, []);

  /**
   * Handle login button click
   */
  const handleLogin = (): void => {
    dispatch(loginUser({ email: inputEmail, password: inputPassword, rememberMe }));
  };

  /**
   * Handle email input change
   * @param e email field change event
   */
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setInputEmail(e.target.value);
  };

  /**
   * Handle password input change
   * @param e pasword field change event
   */
  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setInputPassword(e.target.value);
  };
  
  /**
   * Toggle password visibility
   */
  const togglePasswordVisibility = (): void => {
    setShowPassword(!showPassword);
  };

  /**
   * Handle remember me checkbox change
   */
  const handleRememberMeChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setRememberMe(e.target.checked);
  };


  return (
    <LoginSingupLayout>
        <Title>Facility Admin Login</Title>
        <Subtext>Log in to manage your facility</Subtext>
        <form>
          <Label htmlFor="email">Email ID*</Label>
          <Input value={inputEmail} onChange={handleEmailChange} id="email" type="email" placeholder="name@email.com" />

          <Label htmlFor="password">Password / ID*</Label>
          <InputGroup>
            <PasswordInput value={inputPassword} onChange={handlePasswordChange} id="password" type={(showPassword)?"text":"password"} placeholder="Enter your password" />
            <IconPlaceholder aria-label="Show password icon">
              {(showPassword)?
                <VisibilityOffIcon onClick={togglePasswordVisibility} />
                :
                <RemoveRedEyeIcon onClick={togglePasswordVisibility} />
              }
            </IconPlaceholder>
          </InputGroup>

          <CheckboxGroup>
            <CheckboxLabel>
              <input 
                type="checkbox" 
                id="remember" 
                checked={rememberMe}
                onChange={handleRememberMeChange}
              />
              Remember Me
            </CheckboxLabel>
            <LinkText href="/forgot-password">Forgot Password?</LinkText>
          </CheckboxGroup>

          <Button type="button" onClick={handleLogin} disabled={isLoading}>Log In</Button>
          {error && <ErrorText>{error}</ErrorText>}
        </form>
    </LoginSingupLayout>
  );
};

export default LoginPage;

